export default __webpack_public_path__ + "static/media/tiktok.4433e95e.svg";